import { render, staticRenderFns } from "./DataLabelGroup.vue?vue&type=template&id=096d4c92&scoped=true&"
import script from "./DataLabelGroup.vue?vue&type=script&lang=js&"
export * from "./DataLabelGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d4c92",
  null
  
)

export default component.exports